import { useQuery } from '@apollo/client/react';
import { GET_CUSTOMER_DELIVERY_TYPES_QUERY } from '../../integrations/allkort/graphql/gql/CustomerQueries';
import {
	CustomerDeliveryTypesResponse,
	InvoiceDelivery,
	StatementDelivery,
} from '../../integrations/allkort/graphql/interface/Customer';

/**
 * Custom hook for fetching the customer's preferred delivery types
 * for invoices and prepaid statements in a single request.
 *
 * Usage:
 * const { invoiceDelivery, statementDelivery, loading, error } = useGetDeliveryTypes();
 *
 * @returns invoiceDelivery - customer's preferred invoice delivery (null if not set)
 * @returns statementDelivery - customer's preferred statement delivery (null if not set)
 */
export const useGetDeliveryTypes = (): {
	invoiceDelivery: InvoiceDelivery | null;
	statementDelivery: StatementDelivery | null;
	loading: boolean;
	error: Error | undefined;
	refetch: () => void;
} => {
	const { data, loading, error, refetch } = useQuery<CustomerDeliveryTypesResponse>(
		GET_CUSTOMER_DELIVERY_TYPES_QUERY,
		{ fetchPolicy: 'network-only' }
	);

	return {
		invoiceDelivery: data?.currentCustomer?.invoiceDelivery ?? null,
		statementDelivery: data?.currentCustomer?.statementDelivery ?? null,
		loading,
		error,
		refetch,
	};
};
